import { createMuiTheme } from '@material-ui/core/styles';
const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#69e8c3',
    },
    secondary: {
      main: '#78b8ff',
    },
    background: {
      default: '#08101f',
      paper: '#121a2f'
    }
  },
  typography: {
    fontFamily: 'Manrope, Arial, sans-serif',
  },
});

export default theme;
